export const TABS = {
  GLOBAL_AVERAGE: "Global average",
  DAY_BY_DAY: "Day by day breakdown",
  PROJECT_SNAPSHOTS: "Reports",
};
